/**
 * Component to add JSON-LD structured data to the page
 * This component renders JSON-LD scripts in the document head
 */

interface JsonLdProps {
  data: Record<string, any> | Array<Record<string, any>>;
  id?: string;
}

export default function JsonLd({ data, id }: JsonLdProps) {
  return (
    <script 
      type="application/ld+json"
      id={id ? `json-ld-${id}` : undefined}
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
} 